import { BaseWithId } from '@app/shared/models/base';
import * as _ from 'lodash-es';
import { TranslationEntry } from '@app/shared/models/translatable';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { AlphabetFilterable } from '@app/shared/models/search-filter';
import { ActionListItem } from '@app/shared/components/action-list/action-list.component';

export enum ClaimNetChannelEnum {
    DYNAREX = 'claimnetDYNAREX',
    DESIRE = 'claimnetDESIRE',
    MY_CLAIM = 'claimnetMyClaim',
    THREE_C = 'claimnet3C',
    FAIRE_REG = 'claimnetFaireRegulierung',
    SOFT_PROJECT = 'claimnetSoftProject'
}

export enum ClaimNetSubChannel {
    SDII = 'SDII',
    SD3 = 'SD3'
}

export class ClaimNetChannels {
    public static readonly ALL: TranslationEntry[] = [
        { key: ClaimNetChannelEnum.DYNAREX, trans: 'DYNAREX' },
        { key: ClaimNetChannelEnum.DESIRE, trans: 'DESIRE' },
        { key: ClaimNetChannelEnum.MY_CLAIM, trans: 'myClaim' },
        { key: ClaimNetChannelEnum.THREE_C, trans: '3C' },
        { key: ClaimNetChannelEnum.FAIRE_REG, trans: 'FaireRegulierung' },
        { key: ClaimNetChannelEnum.SOFT_PROJECT, trans: 'SoftProject' }
    ];

    public static getByKey(key: ClaimNetChannelEnum): TranslationEntry {
        let found = _.find(ClaimNetChannels.ALL, (type: TranslationEntry) => type.key === key);
        if (!found) {
            found = {
                key: key,
                trans: key
            } as TranslationEntry;
        }
        return found;
    }

    public static get DYNAREX() {
        return ClaimNetChannels.getByKey(ClaimNetChannelEnum.DYNAREX);
    }

    public static get DESIRE() {
        return ClaimNetChannels.getByKey(ClaimNetChannelEnum.DESIRE);
    }

    public static get MY_CLAIM() {
        return ClaimNetChannels.getByKey(ClaimNetChannelEnum.MY_CLAIM);
    }

    public static get THREE_C() {
        return ClaimNetChannels.getByKey(ClaimNetChannelEnum.THREE_C);
    }

    public static get FAIRE_REG() {
        return ClaimNetChannels.getByKey(ClaimNetChannelEnum.FAIRE_REG);
    }
}

export class RecipientOptionsSubChannels {
    public static readonly ALL: TranslationEntry[] = [
        { key: ClaimNetSubChannel.SDII, trans: 'SilverDAT II' },
        { key: ClaimNetSubChannel.SD3, trans: 'SilverDAT 3' }
    ];

    public static getByKey(key: ClaimNetSubChannel): TranslationEntry {
        let found = _.find(ClaimNetChannels.ALL, (type: TranslationEntry) => type.key === key);
        found = found ? found : _.find(ClaimNetChannels.ALL, (type: TranslationEntry) => type.key === null);
        return found;
    }

    public static get SDII() {
        return RecipientOptionsSubChannels.getByKey(ClaimNetSubChannel.SDII);
    }

    public static get SD3() {
        return RecipientOptionsSubChannels.getByKey(ClaimNetSubChannel.SD3);
    }
}

export class RecipientOptions extends BaseWithId
                              implements AlphabetFilterable, ActionListItem {

    public recipient_name: string;
    public recipient_id: string;

    public channel: ClaimNetChannelEnum;
    public sub_channel: ClaimNetSubChannel;
    public sub_channel_value: string;

    public merge_documents: boolean;
    public remove_images: boolean;
    public readonly: boolean;
    public hidden: boolean;
    public max_filesize: number;

    get actionListDisplayName(): string {
        return this.recipient_name;
    }

    get alphabetFilterOn(): string[] {
        return [this.actionListDisplayName];
    }

    get hasSubChannel(): boolean {
        return this.channel && this.channel === ClaimNetChannelEnum.MY_CLAIM;
    }

    get recipientIdLabel(): string {
        return this.channel ?
                 (this.channel === ClaimNetChannelEnum.THREE_C  ?
                     this.trans.recipient_id_3c :
                    (this.channel === ClaimNetChannelEnum.MY_CLAIM  ?
                         this.trans.recipient_id_my_claim :
                        (this.channel === ClaimNetChannelEnum.DYNAREX  ?
                            this.trans.recipient_id_dynarex :
                            this.trans.recipient_id))) :
               this.trans.recipient_id;
    }

    public readonly trans = {
        recipient_name: marker('recipient_options.recipient_name'),
        recipient_id: marker('recipient_options.recipient_id'),
        recipient_id_3c: marker('recipient_options.recipient_id_3c'),
        recipient_id_my_claim: marker('recipient_options.recipient_id_my_claim'),
        recipient_id_dynarex: marker('recipient_options.recipient_id_dynarex'),
        channel: marker('recipient_options.channel'),
        sub_channel: marker('recipient_options.sub_channel'),
        merge_documents: marker('recipient_options.merge_documents'),
        remove_images: marker('recipient_options.remove_images'),
        max_filesize: marker('recipient_options.max_filesize')
    };

    constructor(json?: any) {
        super(json);
    }

    public setChannel(channel: TranslationEntry) {
        this.channel = channel ? channel.key as ClaimNetChannelEnum : null;
    }

    public setSubChannel(subChannel: TranslationEntry) {
        this.sub_channel = subChannel ? subChannel.key as ClaimNetSubChannel : null;
        this.sub_channel_value = subChannel ? subChannel.trans : null;
    }
}
